export default "__VITE_ASSET__29f3b2b2__"